import { IReportResponse } from '@/interfaces/report';
import { getListClientReport } from '@/services/apis/modules/indicator-reports';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
interface IGetReports {
  body: {
    keyword: string;
    pageIndex: number;
    pageSize: number;
    sortBy: string;
    id?: string | null | undefined;
  };
}

interface IState {
  loading: boolean;
  reports: IReportResponse | undefined;
  error: string;
}
const initialState: IState = {
  loading: false,
  reports: undefined,
  error: '',
};

export const fetchListReports = createAsyncThunk(
  '/reports',
  async (arg: IGetReports) => {
    const { body } = arg;
    const { id, ...filteredBody } = body;
    const requestBody = id ? { ...filteredBody, id } : filteredBody;
    const res = await getListClientReport(requestBody);
    return res;
  },
);

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchListReports.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchListReports.fulfilled, (state, action) => {
      state.loading = false;
      state.reports = action.payload;
      state.error = '';
    });
    builder.addCase(fetchListReports.rejected, (state) => {
      state.loading = true;
      state.reports = undefined;
    });
  },
});

export default reportsSlice.reducer;
